<template>
  <section class="change-password-stepper-wrapper__form ion-padding">
    <Form
      form-name="changePassword"
      id="changePasswordForm"
      :validation-schema="schemaChangePassword"
      @submit="handleChangePasswordSubmit"
    >
      <ion-row>
        <ion-col size="12">
          <swiper ref="changePasswordSwiper" :modules="[Navigation]" @swiper="onSwiper">
            <swiper-slide>
              <ion-row>
                <ion-col size="12">
                  <h4 class="h4 mt-8">{{ t('actions.changePassword') }}</h4>
                  <p class="text-color-body text-align-left font-xs mt-lg">
                    {{ t('signUp.passwordDescription') }}
                  </p>
                  <ul class="font-xs">
                    <li>{{ t('signUp.passwordDescriptionLeast.minCharacters') }}</li>
                    <li>{{ t('signUp.passwordDescriptionLeast.uppercase') }}</li>
                    <li>{{ t('signUp.passwordDescriptionLeast.lowercase') }}</li>
                    <li>{{ t('signUp.passwordDescriptionLeast.number') }}</li>
                    <li>{{ t('signUp.passwordDescriptionLeast.special') }}</li>
                  </ul>
                  <div class="mt-32 mb-16">
                    <CustomInput
                      form-name="change-password"
                      type="password"
                      :value="newPasswordInput"
                      v-model="newPasswordInput"
                      input-type="password"
                      :label="t('profile.password.newPassword')"
                      name="newPassword"
                      class-name="custom-field"
                      :placeholder="t('profile.password.newPassword')"
                      :icon="lockClosedOutline"
                      :clear-field="false"
                    />
                  </div>
                  <div class="mt-32 mb-16">
                    <CustomInput
                      form-name="change-password"
                      type="password"
                      :value="newPasswordConfirmInput"
                      v-model="newPasswordConfirmInput"
                      input-type="password"
                      :label="t('profile.password.confirmPassword')"
                      name="confirmPassword"
                      class-name="custom-field"
                      :placeholder="t('profile.password.confirmPassword')"
                      :icon="lockClosedOutline"
                      :clear-field="false"
                    />
                  </div>
                </ion-col>
              </ion-row>
            </swiper-slide>
          </swiper>
        </ion-col>
      </ion-row>
      <ion-row class="mt-16">
        <ion-col size="5">
          <ion-button
            expand="block"
            color="primary"
            fill="clear"
            class="text-weight-bold"
            @click="$emit('close')"
            >{{ t('actions.cancel') }}
          </ion-button>
        </ion-col>
        <ion-col size="7">
          <ion-button
            :disabled="isLoading"
            expand="block"
            color="primary"
            fill="solid"
            class="text-weight-bold"
            type="submit"
            >{{ t('actions.changePassword') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </Form>
    <ion-progress-bar v-if="isLoading" type="indeterminate" class="mt-xs"></ion-progress-bar>
  </section>
</template>
<script setup lang="ts">
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Navigation } from 'swiper/modules';
  import { lockClosedOutline } from 'ionicons/icons';
  import { IonButton, IonCol, IonRow, IonProgressBar } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { Form } from 'vee-validate';
  import { useProfile } from '@/composables/useProfile';
  import { ref } from 'vue';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { useSchemas } from '@/composables/useSchemas';

  const { schemaChangePassword } = useSchemas();
  const { t } = useI18n();
  const {
    swiperChangePassword,
    toggleChangePassword,
    changePasswordSuccess,
    handleChangePassword,
  } = useProfile();
  const emit = defineEmits(['close']);
  const isLoading = ref(false);

  const currentPasswordInput = ref('');
  const newPasswordInput = ref('');
  const newPasswordConfirmInput = ref('');

  function onSwiper(swiper: any) {
    swiperChangePassword.value = swiper;
  }

  const handleChangePasswordSubmit = () => {
    isLoading.value = true;
    handleChangePassword(currentPasswordInput.value, newPasswordInput.value).then(() => {
      if (changePasswordSuccess.value) {
        toggleChangePassword.value = false;
        currentPasswordInput.value = '';
        newPasswordInput.value = '';
        newPasswordConfirmInput.value = '';

        emit('close');
      }

      isLoading.value = false;
    });
  };
</script>
<style scoped lang="scss">
  .change-password-stepper-wrapper {
    &__form {
      width: 100%;
      border-radius: 16px;
      background: #ffffff;
    }
  }

  .swiper {
    overflow: visible !important;
  }

  .swiper-slide-prev,
  .swiper-slide-next {
    visibility: hidden;
  }

  .dp__outer_menu_wrap,
  .dp--menu-wrapper {
    overflow: hidden;
    background: #1c4197;
  }
</style>
